(function (Translator) {
    // et
    Translator.add("administration.user_search_button", "Otsing", "EvpAdministrationBundle", "et");
    Translator.add("administration.user_search_label", "Kasutajanimi", "EvpAdministrationBundle", "et");
    Translator.add("forbidden", "Ei ole lubatud", "EvpAdministrationBundle", "et");
    Translator.add("internal_server_error", "Serveri viga", "EvpAdministrationBundle", "et");
    Translator.add("invalid_code", "Vale kood", "EvpAdministrationBundle", "et");
    Translator.add("invalid_grant", "Juurdep\u00e4\u00e4s puudub", "EvpAdministrationBundle", "et");
    Translator.add("invalid_parameters", "Valed parameetrid", "EvpAdministrationBundle", "et");
    Translator.add("invalid_request", "Kehtetu p\u00e4ring", "EvpAdministrationBundle", "et");
    Translator.add("invalid_state", "Vale staatus", "EvpAdministrationBundle", "et");
    Translator.add("limits_exceeded", "Limiit on saavutatud", "EvpAdministrationBundle", "et");
    Translator.add("logout", "Logi v\u00e4lja", "EvpAdministrationBundle", "et");
    Translator.add("not_acceptable", "Vastu v\u00f5tmata", "EvpAdministrationBundle", "et");
    Translator.add("not_found", "Ei leitud", "EvpAdministrationBundle", "et");
    Translator.add("pagination.first", "Esimene", "EvpAdministrationBundle", "et");
    Translator.add("pagination.last", "Viimane", "EvpAdministrationBundle", "et");
    Translator.add("pagination.next", "J\u00e4rgmine", "EvpAdministrationBundle", "et");
    Translator.add("pagination.page_out_of", "alates", "EvpAdministrationBundle", "et");
    Translator.add("pagination.previous", "Tagasi", "EvpAdministrationBundle", "et");
    Translator.add("rate_limit_exceeded", "Limiit on saavutatud", "EvpAdministrationBundle", "et");
    Translator.add("unauthorized", "Juurdep\u00e4\u00e4s puudub", "EvpAdministrationBundle", "et");
})(Translator);
